export const NAME = "loggedInUser";
